module.exports = __webpack_public_path__ + "img/g3.31d5028b.jpg";